import { MainMenu } from 'rangeConfig/@types';
import platform from 'rangeConfig/shared/utils/platform';
import AgeGroupSwitcher from 'components/AgeGroupSwitcher/AgeGroupSwitcher';

const widgets = {
  desktop: [],
  mobile: [
    {
      id: 'agetGroupToggle',
      component: AgeGroupSwitcher
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.ageGroup',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  widgets: widgets[platform]
};

export default mainMenu;
